export const TELECARE_LOGO_SRC = "/telecare-logo.svg";

export const getHospitalLogoSrc = () => {
  if (process.env.REACT_APP_ENVIRONMENT === "local") {
    return "/telecare-logo.svg";
  }
  switch (process.env.REACT_APP_HOSPITAL_NAME) {
    case "MACKAY_EYE":
      return "/mackay-eye-logo.png";
    case "WIDE_BAY":
      return "/wide-bay-logo.png";
    case "CENTRAL_QLD_HHS":
      return "/central-qld-hhs-logo.png";
    case "CAIRNS_HINTERLAND_HHS":
      return "/chhhs-logo.png";
    case "MB_PSYCHOLOGY":
      return "/amplar-health-logo.svg";
    case "RURAL_HEALTH_CONNECT":
      return "/rural-health-connect-logo.webp";
    case "METRO_NORTH_HHS":
      return "/metro-north-hhs-logo.png";
    default:
      return "/telecare-logo.svg";
  }
};

export const getHospitalLogoClassName = (klassName = "logo") => {
  if (process.env.REACT_APP_HOSPITAL_NAME === "RURAL_HEALTH_CONNECT") {
    return klassName === "logo-large" ? "rural-health-connect-logo-large" : "rural-health-connect-logo";
  }
  return klassName;
};
